import { useModalState } from "@src/lib/ui-react";
import { useCallback, useState } from "react";

import { useLogHomeHealthCasesListViewed } from "../../lib/useLogHomeHealthPageViewed";
import { useAgencyCases } from "../api/useAgencyCases";
import { type Case, CaseSort, CaseStatus } from "../types";
import { MobileCaseReopenDialog } from "./MobileCaseReopenDialog";
import { MobileCasesListView } from "./MobileCasesListView";

export function MobileCasesListContainer() {
  useLogHomeHealthCasesListViewed();

  const [status, setStatus] = useState<CaseStatus>(CaseStatus.OPEN);
  const [caseToReopen, setCaseToReopen] = useState<Case | undefined>();
  const reopenDialogState = useModalState();

  const {
    data: cases = [],
    isLoading,
    isError,
    refetch,
  } = useAgencyCases({
    filter: { status },
    sort: CaseSort.CREATED_AT_DESC,
  });

  const handleReopen = useCallback(
    (caseItem: Case) => {
      setCaseToReopen(caseItem);
      reopenDialogState.openModal();
    },
    [reopenDialogState]
  );

  return (
    <>
      <MobileCasesListView
        cases={cases}
        status={status}
        onChangeStatus={setStatus}
        isLoading={isLoading}
        isError={isError}
        onRefresh={refetch}
        onReopen={handleReopen}
      />
      <MobileCaseReopenDialog caseToReopen={caseToReopen} modalState={reopenDialogState} />
    </>
  );
}
